import 'katex/dist/katex.min.css'
import Latex from 'react-latex-next';

// import ModelSvg from './CombScheme';
import {ReactComponent as FittingSvg} from './fitting_scheme_2.svg';
import {ReactComponent as ModelSvg} from './comb_scheme_4.svg';


export const Model = () => (
  <>
    <h3>Model</h3>
    <Latex strict>
      A lipid $l$ with $n$ fatty acids can be abstractly denoted as a $n$-tuple $(f_1, \dots, f_k)$.
      The probability $y$ of any molecular species $c=(f_1, \dots, f_k)$ then is just the product of the probabilities $x$ of its fatty acids $f$.

{`$$
\\begin{equation}
    y_{ms,c} = \\prod_{f_i \\in c} x_{f_i}
\\end{equation}
$$`}

      The theoretical lipid profile of considering all molecular species, then results from considering all possible permutations of the available fatty acids.
      If we cannot differentiate between different permutations of the same fatty acids, we can simplify the profile calculation by only considering unique combinations $c$ and weighing them by the number of possible permutations of this combination $p_c$.
      The resulting lipid profile with resolved molecular species then is obtained via .

{`$$
\\begin{align}
  Y_{ms} = 
    \\begin{bmatrix}
    y_{ms,1} \\\\
    \\vdots \\\\
    y_{ms,m}
    \\end{bmatrix}
    =
    \\begin{bmatrix}
    p_{c,1} \\cdot \\prod_{f_i\\in c'_1} x_{f_i} \\\\
    \\vdots \\\\
    p_{c,m} \\cdot \\prod_{f_i \\in c'_m} x_{f_i}
    \\end{bmatrix}
  \\end{align}
$$`}
    Since molecular species are usually not resolved in lipidomic analysis and only reported as sum of carbon chain length and double bonds, we need to group the molecular species based on these features.
    Consequently, $C_l$ denotes such a grouping and is the set of all fatty acid combinations $c'$, which have the same sum of carbon chain length and double bonds as the reported lipid $l$.
    The probability of lipid $y_l$ then equals to the sum of the probabilities of the individual molecular species, yielding a theoretical lipid profile with the same resolution as the experiment.


{`$$
\\begin{align}
  Y = 
	\\begin{bmatrix}
	y_{1} \\\\
	\\vdots \\\\
	y_{m}
	\\end{bmatrix}
	=
	\\begin{bmatrix}
	\\sum_{c' \\in C_1} p_{C'} \\cdot \\prod_{f_i\\in C'} x_{f_i} \\\\
	\\vdots \\\\
	\\sum_{c' \\in C_m} p_{C'} \\cdot \\prod_{f_i \\in C'} x_{f_i}
	\\end{bmatrix}
\\end{align}
$$`}
    </Latex>
    <p>
      The simplified schematic below visualizes the main idea behind this stochastic model. Here, only the carbon chain length dimension is considered. However, in actuality, an additional dimension, the sum of double bonds, has to be considered in the grouping step.
      <ModelSvg />
    </p>
    <p>
      This mathematical model can be fitted to the experimental data, which allows computing the optimal fatty acid distribution to explain the observed lipid profile.
      <FittingSvg />
    </p>
  </>
)



